import { render, staticRenderFns } from "./LocationsPerSite.vue?vue&type=template&id=0908fe15&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./LocationsPerSite.vue?vue&type=script&lang=js"
export * from "./LocationsPerSite.vue?vue&type=script&lang=js"
import style0 from "./LocationsPerSite.vue?vue&type=style&index=0&id=0908fe15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0908fe15",
  null
  
)

export default component.exports